var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('span',{staticClass:"is-ellipsed"},[_c('icon-area',{staticClass:"card-icon"}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }